<template>
  <div class="webdatalist">
  <f7-list media-list class="searchbar-found" id="attachment-list">
    <f7-list-group v-for="(group, key) in Attachments" :key="key">
      <f7-list-item :title="key" group-title></f7-list-item>

        <div class="showSmallScreenOnly">
          <ul>
          <li v-for="data in group" :key="data.id" class="swipeout" @click="view(data.id)">
            <div class="item-content swipeout-content">
              <div class="item-media">
                <i class="icon list-icon icon-invoice"></i>
              </div>
              <div class="item-inner">
                <div class="item-title">{{ data.name }}</div>
                <div class="item-after">{{ data.type }}</div>
              </div>
            </div>
            <div class="swipeout-actions-right">
              <a href="#" class="swipeout-delete"
                data-confirm="You won't be able to recover this file from MoneyRoad"
                data-confirm-title="Remove?"
                data-close-on-cancel="true"
                delete>
                Remove
              </a>
            </div>
          </li>
          </ul>
        </div>
        <div class="showLargeScreenOnly">
          <ul>
            <li v-for="data in group" :key="data.id" >
              <div class="item-content boxRequest">
                <div class="item-media">
                  <i class="icon list-icon icon-invoice"></i>
                </div>
                <div class="item-inner" @click="view(data.id)">
                  <div class="item-title">{{ data.name }}</div>
                  <div class="item-after">{{ data.type }}</div>
                </div>
                <div class="item-media">
                  <button class="button-swipe-out" @click="removeAttachmentWeb(data.id)"
                    :disabled="$engine.rights.rightIs('attachment_supprimer', false)">
                    <!-- <i class="fa fa-times-circle button-delete" style="color: red;font-size: larger;"></i> -->
                    <f7-icon f7="close" class="button-delete" style="font-size:larger"
                    v-bind:style="[$engine.rights.rightIs('attachment_supprimer', false) ? {'color':'grey'} : {'color':'red'}]"></f7-icon>
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
    </f7-list-group>
  </f7-list>
</div>
</template>

<script>
// import {del} from '@/helpers/api'
import b64toBlob from 'b64-to-blob'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'AttachmentList',
  props: ['Attachments', 'filterBy', 'service'],
  // updated: function () {
  //   let that = this
  //   var files = [...document.getElementsByClassName('attachmentTaphold')]
  //   console.log(files)
  //   files.forEach(function (element) {
  //     that.enableClick(element.id)
  //   })
  // },
  computed: {
    ifAndroid: function () {
      if (this.$f7.device.os === 'android') {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    onSwipeoutDeleted () {
      alert('deleted')
    },
    removeAttachmentWeb (fileId) {
      let that = this
      this.$f7.modal({
        title: that.$t('attachments.want_to_remove_attachment'),
        buttons: [
          {
            text: that.$t('common.cncl'),
            color: 'red',
            onClick: function () {
            }
          },
          {
            text: that.$t('common.yes_label'),
            onClick: function () {
              that.removeAttachment(fileId)
            }
          }
        ]
      })
    },
    removeAttachment (fileId) {
      let that = this
      this.$engine.attachments
        .del(fileId) // Envoi à la modé de la suppression de l'attachment
        .then(() => {
          that.$bus.$emit('refresh-cache-attachments')
          var idAttachmentInList = -1
          var filteredListAtt = that.Attachments

          for (var keys in filteredListAtt) {
            for (var att in filteredListAtt[keys]) {
              if (filteredListAtt[keys][att].id === fileId) {
                idAttachmentInList = att.id
                break
              }
            }
            if (idAttachmentInList !== -1) {
              filteredListAtt[keys].splice(idAttachmentInList, 1)
              break
            }
          }
          /* that.$f7.alert('', 'File Removed') */
        })
        .catch(err => {
          this.handleError(err) // mixins errorHandlerMixins
        })
    },
    disableClick (fileId) {
      // let txt = 'EVENT swipe open : ' + fileId
      // console.log(txt)
      document.getElementById(fileId).onclick = function () {
        // alert('click disabled')
      }
    },
    enableClick (fileId) {
      let that = this
      // let txt = 'EVENT swipe closed : ' + fileId
      document.getElementById(fileId).onclick = function () {
        // alert('click enabled')
        that.view(fileId)
      }
    },
    openPayments (fileId, fileName) {
      this.$f7.showPreloader('Charge File')
      let that = this
      let attachmentObj = {
        fromCloudList: true,
        id: 0,
        name: '',
        data: '',
        reference: '',
        amount: 0,
        executionDate: '',
        debtorName: '',
        debtorEmail: '',
        debtorBankAccount: '',
        remittanceInformation: ''
      }
      this.$engine.attachments.download(fileId)
        .then(response => {
          attachmentObj.name = response.data.document_name
          attachmentObj.data = response.data.document_data
          attachmentObj.id = response.data.id_cloud_document
          this.$engine.attachments.getRecommendedInfo(fileId)
            .then(response => {
              that.$f7.hidePreloader()
              attachmentObj.reference = response.data.reference
              attachmentObj.amount = response.data.amount
              attachmentObj.executionDate = response.data.reqstdExecDate
              attachmentObj.debtorName = response.data.debtorName
              attachmentObj.debtorEmail = response.data.debtorEmail
              attachmentObj.debtorBankAccount = response.data.debtorBankAccount
              attachmentObj.remittanceInformation = response.data.remittanceInformation
              that.$engine.settings.set({preChargedFile: attachmentObj})

              if (this.service === 'Payments') {
                loadPage(this, {url: '/payments/newPayments/'})
              } else if (this.service === 'Direct Payments') {
                loadPage(this, {url: '/directPayments/newDirectPayments/'})
              }
            })
            .catch(error => {
              that.$f7.hidePreloader()
              errorMessageAlert(error, that)
            })
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
    },
    writeToFile (fileName, data, fileType, readonly, success, error) {
      /* eslint-disable no-undef */
      let that = this
      let directory = ''

      if (readonly) {
        if (that.$f7.device.os === 'android') {
          directory = cordova.file.externalDataDirectory
        } else if (that.$f7.device.os === 'ios') {
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }

        that.saveFileToDirectory(fileName, data, fileType, directory, success, error)
      } else {
        // directory = cordova.file.externalRootDirectory
        if (that.$f7.device.os === 'android') {
          directory = cordova.file.externalRootDirectory
        } else if (that.$f7.device.os === 'ios') {
          // directory = cordova.file.dataDirectory
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        try {
          that.checkForWritePermissions(function () {
            try {
              window.resolveLocalFileSystemURL(directory, function (directoryEntry) {
                directoryEntry.getDirectory('Download', {create: true}, function (downloadDir, _data) {
                  // console.log('sucess getting download directory')
                  // console.log(downloadDir)
                  that.saveFileToDirectory(fileName, data, fileType, downloadDir.nativeURL, function (filePath, fileType) {
                    // console.log('sucess saving file: ', filePath)
                  }, function (error, _data) {
                    console.error('error on saving file' + error.code)
                    alert(that.$t('errors.unbl_sv_fl') + error.code)
                  })
                }, function (error, _data) {
                  console.error('error on accessing download directory' + error.code)
                  alert('Unable to get/create download directory: ' + error.code)
                })
              }, (e, file) => { // error resolveLocalFileSystemURL
              })
            } catch (error) { // get dir
              console.error(error)
            }
          }, function () {
            alert('App needs access to the phone\'s file storage in order to save files.')
          })
        } catch (error) { // get perms
          console.error(error)
        }
      }
      /* eslint-enable no-undef */
    },
    // writeToFile (fileName, data, fileType, readonly, success, error) {
    //   /* eslint-disable no-undef */
    //   let that = this
    //   let directory = ''
    //
    //   if (readonly) {
    //     if (that.$f7.device.os === 'android') {
    //       directory = cordova.file.externalDataDirectory
    //     } else if (that.$f7.device.os === 'ios') {
    //       directory = cordova.file.tempDirectory
    //     } else {
    //       directory = cordova.file.dataDirectory
    //     }
    //     that.saveFileToDirectory(fileName, data, fileType, directory, success, error)
    //   } else {
    //     directory = cordova.file.externalRootDirectory
    //     try {
    //       that.checkForWritePermissions(function () {
    //         try {
    //           window.resolveLocalFileSystemURL(directory, function (directoryEntry) {
    //             directoryEntry.getDirectory('Download', {create: true}, function (downloadDir, _data) {
    //               console.log('sucess getting download directory')
    //               console.log(downloadDir)
    //               that.saveFileToDirectory(fileName, data, fileType, downloadDir.nativeURL, function (filePath, fileType) {
    //                 console.log('sucess saving file: ', filePath)
    //               }, function (error, _data) {
    //                 console.error('error on saving file' + error.code)
    //                 alert('Unable to save file: ' + error.code)
    //               })
    //             }, function (error, _data) {
    //               console.error('error on accessing download directory' + error.code)
    //               alert('Unable to get/create download directory: ' + error.code)
    //             })
    //           }, (e, file) => { // error resolveLocalFileSystemURL
    //           })
    //         } catch (error) { // get dir
    //           console.error(error)
    //         }
    //       }, function () {
    //         alert('App needs access to the phone\'s file storage in order to save files.')
    //       })
    //     } catch (error) { // get perms
    //       console.error(error)
    //     }
    //   }
    //   /* eslint-enable no-undef */
    // },
    checkForWritePermissions (sucess, error) {
      /* eslint-disable no-undef */
      cordova.plugins.diagnostic.requestRuntimePermission(function (status) {
        switch (status) {
          case cordova.plugins.diagnostic.permissionStatus.GRANTED:
            // console.log('Permission granted')
            sucess()
            break
          case cordova.plugins.diagnostic.permissionStatus.DENIED:
            // console.log('Permission denied')
            error()
            break
          case cordova.plugins.diagnostic.permissionStatus.DENIED_ALWAYS:
            // console.log('Permission permanently denied')
            error()
            break
        }
      }, function (error) {
        console.error('The following error occurred: ' + error)
      },
        cordova.plugins.diagnostic.permission.WRITE_EXTERNAL_STORAGE
      )
      /* eslint-enable no-undef */
    },
    saveFileToDirectory (fileName, data, fileType, directory, success, error) {
      /* eslint-disable no-undef */
      let directoryEntryReference = null
      window.resolveLocalFileSystemURL(directory, function (directoryEntry) {
        directoryEntryReference = directoryEntry
        directoryEntry.getFile(fileName, { create: true, exclusive: true }, function (fileEntry) {
          fileEntry.createWriter(function (fileWriter) {
            fileWriter.onwriteend = function (e) {
              success(e.target.localURL, fileType, fileName)
            }
            fileWriter.onerror = function (e) {
              error()
            }
            let blob = b64toBlob(data.replace(/^data:\w+\/\w+;base64,/, ''), fileType)
            fileWriter.write(blob)
          }, (e, file) => {
          })
        }, (e, file) => {
          navigator.notification.confirm('This file already exists. Do you want to override it ? (' + fileName + ')', function (index) {
            // console.log('Do you want to override the following file: ' + fileName + ' (' + index + ')')
            switch (index) {
              case 1: // No
                // console.log('No. Returning to idle state.')
                break
              case 2: // Yes -> overrides  the file
                // console.log('Yes. Overriding file.')
                directoryEntryReference.getFile(fileName, { create: true, exclusive: false }, function (fileEntry) {
                  fileEntry.createWriter(function (fileWriter) {
                    fileWriter.onwriteend = function (e) {
                      success(e.target.localURL, fileType, fileName)
                    }
                    fileWriter.onerror = function (e) {
                      error()
                    }
                    let blob = b64toBlob(data.replace(/^data:\w+\/\w+;base64,/, ''), fileType)
                    fileWriter.write(blob)
                  }, (e, file) => {
                  })
                }, (e, file) => {
                })
                break
            }
          }, 'Information', ['No', 'Yes'])
        })
      }, (e, file) => { // error resolveLocalFileSystemURL
      })
      /* eslint-enable no-undef */
    },
    errorHandler (fileName, e) {
      var msg = ''
      switch (e.code) {
        case FileError.QUOTA_EXCEEDED_ERR:
          msg = 'Storage quota exceeded'
          break
        case FileError.NOT_FOUND_ERR:
          msg = 'File not found'
          break
        case FileError.SECURITY_ERR:
          msg = 'Security error'
          break
        case FileError.INVALID_MODIFICATION_ERR:
          msg = 'Invalid modification'
          break
        case FileError.INVALID_STATE_ERR:
          msg = 'Invalid state'
          break
        default:
          msg = 'Unknown error'
          break
      }
      this.$f7.alert('', msg)
    },
    readFile (filePath, fileType, fileName) {
      /* eslint-disable no-undef */
      // TODO : test fileType before trying to open and let the user know
      // let directory = cordova.file.tempDirectory
      // let that = this
      // let directory = ''
      //
      // if (that.$f7.device.os === 'android') {
      //   directory = cordova.file.externalDataDirectory
      // } else if (that.$f7.device.os === 'ios') {
      //   directory = cordova.file.tempDirectory
      // } else {
      //   directory = cordova.file.dataDirectory
      // }
      //
      // let file = directory + fileName
      window.resolveLocalFileSystemURL(filePath, function (entry) {
        cordova.plugins.fileOpener2.open(entry.nativeURL.replace(/%20/g, ' '), fileType, {
          error: function (e) {
            // TODO : screen user stuff
          },
          success: function (s) {
            // TODO : screen user stuff
          }
        })
      })
      /* eslint-enable no-undef */
    },
    onShow () {
    },
    onClose () {
    },
    onMissingApp () {
      this.$f7.alert('', 'App missing')
    },
    onError () {
      this.$f7.alert('', 'Viewer error')
    },
    view: function (id) {
      // Get cloudDocument
      // var resource = 'cloudDocument/detail/' + id
      const that = this
      this.$f7.showPreloader('Opening File')
      // let response = this.$engine.user.currentUser.accounts.attachments.download()
      this.$engine.attachments.download(id)
        .then(response => {
          that.$f7.hidePreloader()
          this.$engine.settings.set({Attachment: {
            data: response.data.document_data,
            name: response.data.document_name,
            mimeType: response.data.document_data.split(';')[0].replace(/^data:/, ''),
            id: id
          }})

          if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
            that.writeToFile(
              response.data.document_name,
              response.data.document_data,
              response.data.document_data.split(';')[0].replace(/^data:/, ''),
              true,
              function (filePath, fileType, fileName) {
                that.readFile(filePath, fileType, fileName)
              },
              function () {
                that.$f7.alert('', 'Error creating the file')
              }
            )
          } else {
            let blob = b64toBlob(response.data.document_data.split(',')[1], response.data.document_data.split(';')[0].replace(/^data:/, ''))
            const url = window.URL.createObjectURL(blob)
            const fileLink = document.createElement('a')
            fileLink.href = url
            fileLink.setAttribute('download', response.data.document_name) // or any other extension
            fileLink.click()
          }
          setTimeout(function () { that.$f7.hidePreloader() }, 1000)
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
        })
    },
    download (id) {
      /* eslint-disable no-undef */
      const that = this
      this.$f7.showPreloader('Downloading File')
      this.$engine.services.payments.getAttachmentDetail(id)
        .then(response => {
          that.$f7.hidePreloader()
          this.$engine.settings.set({Attachment: {
            data: response.data.documentData,
            name: response.data.documentName,
            mimeType: response.data.documentData.split(';')[0].replace(/^data:/, ''),
            id: id
          }})
          that.writeToFile(
            response.data.documentName,
            response.data.documentData,
            response.data.documentData.split(';')[0].replace(/^data:/, ''),
            false,
            function (filePath, fileType) {
              that.$f7.alert(filePath.split('/')[filePath.split('/').length - 1], 'Following file successfully saved.')
            },
            function () {
              that.$f7.alert('', 'Error creating the file')
            }
          )
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
        })
    }
  }
}
</script>

<style scoped>
ul {
  padding-left: 0% !important;
}
.fa {
  color: red;
  font-size: xx-large;
}
</style>



// WEBPACK FOOTER //
// CMAttachmentsList.vue?81c56dc8